import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LogoutReasonCode } from '@shared/_constants';
import { AuthService } from '@services/auth.service';

@Component({
  selector: 'app-logged-out',
  templateUrl: './logged-out.component.html',
  styleUrls: ['./logged-out.component.css'],
})
export class LoggedOutComponent implements OnInit {
  public logoutMessage = 'You are currently signed out';
  constructor(private route: ActivatedRoute, private authService: AuthService) {}

  ngOnInit() {
    this.route.queryParamMap.subscribe((queryParams) => {
      const reasonCode = queryParams.get('r');
      if (reasonCode !== undefined && reasonCode !== null && typeof +reasonCode === 'number') {
        this.updateLogoutMessage(+reasonCode);
      }
    });
  }

  public login() {
    this.authService.logIn();
  }

  private updateLogoutMessage(reasonCode: LogoutReasonCode) {
    switch (reasonCode) {
      case LogoutReasonCode.webapiRefreshTokenExpired:
        this.logoutMessage = 'You are currently signed out of the application due to expired access.<br/><br/>Please log back in to continue.';
        break;
      case LogoutReasonCode.inactiveSessionTimeout:
        this.logoutMessage = 'You are currently signed out of the application due to inactivity.<br/><br/>Please log back in to continue.';
        break;
      case LogoutReasonCode.userLoggedOut:
      default:
        this.logoutMessage = 'You are currently signed out';
        break;
    }
  }
}
